import React from 'react';
import { PulseAnimationI } from './interface';
import { PulseAnimationContainer } from './style';

const PulseAnimation: React.FC<PulseAnimationI> = ({ children, ...props }) => {
  return <PulseAnimationContainer {...props}>{children}</PulseAnimationContainer>;
};

export default PulseAnimation;
